import { useEffect, useState } from "react";
import axios from "axios";
import { MoveRight, X } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ROLES = ["Architect", "Interior designer", "Hotel/Resort owner", "Dealers/Distributer", "Other professional"];

export function EnquiryPopup() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", city: "", role: "" });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("ims-popup-done") || window.location.pathname === "/leads") return undefined;
    const timer = setTimeout(() => {
      setOpen(true);
      localStorage.setItem("ims-popup-done", "1");
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!sent) return undefined;
    const closer = setTimeout(() => setOpen(false), 4000);
    return () => clearTimeout(closer);
  }, [sent]);

  const close = () => setOpen(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await axios.post(`${API}/contact`, { ...form, message: "Popup enquiry" });
      setSent(true);
    } catch (err) {
      console.error(err);
      setError("We couldn’t save your enquiry. Please call us at +91 95450 03078.");
    }
  };

  if (!open) return null;

  return (
    <div className="popup-overlay" onClick={close} data-testid="enquiry-popup">
      <div className="popup-panel" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={close} aria-label="Close" data-testid="popup-close-button"><X size={18} /></button>
        <span className="eyebrow">Private consultation</span>
        <h2>Let&apos;s make space<br /><i>for something beautiful.</i></h2>
        {sent ? (
          <div className="success-bold success-bold-dark" data-testid="popup-success-message">
            <h3>Enquiry submitted.</h3>
            <p>Thank you, {form.name.split(" ")[0]} — our design concierge will call you shortly. You&apos;re all set; there&apos;s no need to fill the form again.</p>
          </div>
        ) : (
          <form className="popup-form" onSubmit={submit} data-testid="popup-form">
            <label>Full name<input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your full name" data-testid="popup-name-input" /></label>
            <div className="popup-row">
              <label>Mobile number<input required value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+91" data-testid="popup-phone-input" /></label>
              <label>City<input required value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} placeholder="Where do you live?" data-testid="popup-city-input" /></label>
            </div>
            <label>You are<Select required value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
              <SelectTrigger className="enquiry-select" data-testid="popup-role-select"><SelectValue placeholder="Select what describes you" /></SelectTrigger>
              <SelectContent className="enquiry-select-content">
                {ROLES.map((role) => <SelectItem className="enquiry-select-item" key={role} value={role} data-testid={`popup-role-option-${role.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{role}</SelectItem>)}
              </SelectContent>
            </Select></label>
            {error && <div className="enquiry-error" data-testid="popup-error-message">{error}</div>}
            <button className="enquiry-submit" type="submit" data-testid="popup-submit-button">Book my consultation <MoveRight size={16} /></button>
          </form>
        )}
      </div>
    </div>
  );
}
